import React from 'react';
import { Link } from 'react-router-dom';
import classes from './Footer.module.css';
import LotusLogo from './LotusLogo';
import { APP_STORE_URL, PLAY_STORE_URL } from './StoreButtons';
import { useI18n } from '../i18n/LanguageContext';
import { useContent } from '../content';
import { slugFor } from '../content/slugs';

/** The two evergreen articles we always link from the footer. */
const FOOTER_POST_IDS = ['what-is-manifestation', 'daily-affirmations'];

function Footer() {
  const { t, path, locale } = useI18n();
  const { getPostById } = useContent();

  return (
    <footer className={classes.footer}>
      <div className={classes.inner}>
        <div className={classes.columns}>
          <div className={classes.brandCol}>
            <div className={classes.brandRow}>
              <span className={classes.brandLogo}>
                <LotusLogo />
              </span>
              <span className={classes.brandName}>Manifestify</span>
            </div>
            <p className={classes.tagline}>{t('footer.tagline')}</p>
          </div>

          <nav className={classes.col} aria-label={t('footer.exploreAria')}>
            <h3 className={classes.colTitle}>{t('footer.exploreTitle')}</h3>
            <Link to={path('/')} className={classes.link}>
              {t('footer.home')}
            </Link>
            <Link to={path('/blog')} className={classes.link}>
              {t('footer.blog')}
            </Link>
            {FOOTER_POST_IDS.map((id) => {
              const post = getPostById(id);
              if (!post) return null;
              return (
                <Link key={id} to={path(`/blog/${slugFor(id, locale)}`)} className={classes.link}>
                  {post.title}
                </Link>
              );
            })}
          </nav>

          <nav className={classes.col} aria-label={t('footer.downloadAria')}>
            <h3 className={classes.colTitle}>{t('footer.downloadTitle')}</h3>
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className={classes.link}>
              {t('footer.appStoreLink')}
            </a>
            <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className={classes.link}>
              {t('footer.playStoreLink')}
            </a>
            <a href="mailto:portalstudio.info@gmail.com" className={classes.link}>
              portalstudio.info@gmail.com
            </a>
          </nav>

          <nav className={classes.col} aria-label={t('footer.legalAria')}>
            <h3 className={classes.colTitle}>{t('footer.legalTitle')}</h3>
            <Link to={path('/terms-and-services')} className={classes.link}>
              {t('footer.terms')}
            </Link>
            <Link to={path('/privacy-policy')} className={classes.link}>
              {t('footer.privacy')}
            </Link>
          </nav>
        </div>

        <p className={classes.copyright}>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
      </div>
    </footer>
  );
}

export default Footer;
